import React, { MouseEventHandler } from "react";
import { useNavigate } from "react-router-dom";
import { getPathValue } from "src/utils/queryStringUtil";
import styled from "styled-components";

interface IGProcessProps {
  onClick?: MouseEventHandler<HTMLButtonElement>;
  groupName?: string;
}

const GroupProcessItem = (props: IGProcessProps) => {
  const navigate = useNavigate();
  const group_index: any = getPathValue();
  return (
    <>
      <li>
        <ProcessItemSet
          onClick={() => {
            document.body.style.overflow = "unset";
            navigate("/group-edit/" + group_index, { state: { groupName: props.groupName } });
          }}
        >
          그룹 편집
        </ProcessItemSet>
      </li>
      <li>
        <ProcessItemSet
          onClick={(e) => {
            props.onClick!(e);
          }}
        >
          그룹 삭제
        </ProcessItemSet>
      </li>
    </>
  );
};

const ProcessItemSet = styled.button`
  width: 100%;
  padding: 30px 0;
  border: none;
  background: none;
  color: #7f7f7f;
  font-size: 25px;
  font-family: "Roboto";
`;

export default GroupProcessItem;
